import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {fireStaff, getStaff} from './actions';
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {getDescriptionFromError} from "../utils/errors";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class FireStaffForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.staffId !== prevProps.match.params.staffId) this._load();
  }

  _load() {
    const {staffId} = decodeParams(this.props.match.params);
    this.props.getStaff({staffId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit(e) {
    const {staffId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.fireStaff({...values, staffId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  }

  render() {
    const {staff, form:{getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Fire Staff" loading={loading}>
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Staff"
          >
            {staff.name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Reason"
          >
            {getFieldDecorator('reason', {
              rules: [{
                required: true,
                message: 'Reason is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={hasErrors(getFieldsError())}
              >
                Fire Staff
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

FireStaffForm.propTypes = {
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  fireStaff: PropTypes.func.isRequired,
  getStaff: PropTypes.func.isRequired,
  staff: PropTypes.object.isRequired,
};

const FireStaffPage = Form.create()(FireStaffForm);

const mapStateToProps = state => ({
  loading: state.staff.staffsLoading,
  staff: state.staff.staff || {},
});

const mapDispatchToProps = dispatch => ({
  fireStaff: bindActionCreators(fireStaff, dispatch),
  getStaff: bindActionCreators(getStaff, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FireStaffPage);



// WEBPACK FOOTER //
// ./src/Staff/FireStaffPage.js